export interface IntersectionObserverOptions {
  threshold?: number | number[]
  root?: Element | null
  rootMargin?: string
}

export function observerVisibility(
  elementId: string,
  onVisible: () => void,
  onHidden: () => void,
  options?: IntersectionObserverOptions,
): IntersectionObserver | null {
  const element = document.getElementById(elementId)

  if (!element) {
    return null
  }

  if (!window.IntersectionObserver) {
    onVisible()
    return null
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        onVisible()
      } else {
        onHidden()
      }
    })
  }, options)

  observer.observe(element)
  return observer
}
